module.exports = __webpack_public_path__ + "img/04.04764395.png";